<script>
import { authComputed, authMethods } from '@state/helpers'

import MetisMenu from 'metismenu/dist/metisMenu'

export default {
  components: {},
  props: {
    isCondensed: {
      type: Boolean,
      required: false
    },
    toggleMenu: {
      type: Function,
      required: false,
      default: () => {}
    }
  },
  computed: {
    ...authComputed,
    getMenu: function () {
      return this.$store.state.auth.currentSession ? this.$store.state.auth.currentSession.user.app_sections_tree : []
    }
  },
  updated: function() {
    this.activateMenu()
  },
  mounted: function() {
    this.activateMenu()
    // fix to toggleMenu at menu items click
    document.querySelectorAll('.link-active').forEach(item => {
      item.addEventListener('click', event => {
        this.toggleMenu()
      })
    })
  },
  created: function() {
    if (this.loggedIn){
      this.setUserActiveSection(this.$route.path)
    }
  },
  methods: {
    ...authMethods,
    activateMenu(){
      // eslint-disable-next-line no-unused-vars
      const menuRef = new MetisMenu('#side-menu',{
        activeClass: 'mm-active',
        toggle: true
      })
    }
  },
}
</script>

<template>
  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <ul id="side-menu" class="metismenu">
      <li v-for="(entry, index) in getMenu" :id="`first-lv-${index}-${entry._id}`" :key="isCondensed + index" :class="{ 'mm-active ': entry.children.length > 0 ? entry.children.filter((x) => x.path === $route.path ).length > 0 && !isCondensed : false }" >
        <router-link v-if="'path' in entry && entry.path"  tag="a" :to=" { path: entry.path }" class="link-active" :class="{ 'active': entry.path === $route.path }" aria-expanded="false">
          <i :class="`fad fa-${entry.icon_name || 'chevron-right'} fa-1_5x fa-fw`" ></i>
          <span> {{ $t(`pages.${entry.name}`) }}</span>
        </router-link>
        <a v-else  href="javascript: void(0);" class="has-arrow" :aria-expanded="entry.children.filter((x) => x.path === $route.path ).length > 0">
          <i :class="`fad fa-${entry.icon_name || 'chevron-right'} fa-1_5x fa-fw`" ></i>
          <span> {{ $t(`pages.${entry.name}`) }}</span>
        </a>
        <!-- if menu entry has children -->
        <ul v-if="entry.children.length > 0" class="nav-second-level nav" :class="{ 'mm-show ': entry.children.filter((x) => x.path === $route.path ).length > 0 && !isCondensed }">
          <li v-for="(childsecondlv, chsecondlvidx) in entry.children" :id="`second-lv-${chsecondlvidx}-${entry._id}-${childsecondlv._id}`" :key="isCondensed + chsecondlvidx" :class="{ 'mm-show': childsecondlv.children.length > 0 ? childsecondlv.children.filter((x) => x.path === $route.path ) && !isCondensed : false }">
            <router-link v-if="'path' in childsecondlv && childsecondlv.path" tag="a" :to="{ path: childsecondlv.path }"  :class="{ 'active': childsecondlv.path === $route.path }" >
              <i :class="`fad fa-${childsecondlv.icon_name || 'chevron-right'} fa-1_5x fa-fw`" ></i>
              <span> {{ $t(`pages.${childsecondlv.name}`) }} </span>
            </router-link>
            <a v-else href="javascript: void(0);" class="has-arrow" :aria-expanded="entry.children.filter((x) => x.path === $route.path ).length > 0">
              <i :class="`fad fa-${childsecondlv.icon_name || 'chevron-right'} fa-1_5x fa-fw`" ></i>
              <span> {{ $t(`pages.${childsecondlv.name}`) }} </span>
            </a>
            <!-- if children of menu entry has more children 3rd level max -->
            <ul v-if="childsecondlv.children.length > 0" class="nav-third-level nav" >
              <li v-for="(childthirdlv, chthirdlvidx) in childsecondlv.children" :id="`third-lv-${chthirdlvidx}-${entry._id}-${childsecondlv._id}`" :key="isCondensed + chthirdlvidx">
                <router-link v-if="'path' in childthirdlv && childthirdlv.path" tag="a" :to="{ path: childthirdlv.path }"  :class="{ 'active': childsecondlv.path === $route.path }">
                  <i :class="`fad fa-${childthirdlv.icon_name || 'chevron-right'} fa-1_5x fa-fw`" ></i>
                  <span> {{ $t(`pages.${childthirdlv.name}`) }}</span>
                </router-link>
                <a v-else  href="javascript: void(0);">
                  <i :class="`fad fa-${childthirdlv.icon_name || 'chevron-right'} fa-1_5x fa-fw`" ></i>
                  <span> {{ $t(`pages.${childthirdlv.name}`) }}</span>
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
    <div class="clearfix"></div>
  </div>
  <!-- End Sidebar -->
</template>
